import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.026 3.25h10.052c.208 0 .368 0 .511.015a2.75 2.75 0 0 1 2.45 2.45c.015.143.015.303.015.511v.437c0 .995-.638 1.84-1.527 2.15v3.809c0 .899 0 1.648-.08 2.242-.084.628-.27 1.195-.725 1.65-.456.456-1.023.642-1.65.726-.595.08-1.344.08-2.243.08H8.275c-.899 0-1.648 0-2.243-.08-.628-.084-1.194-.27-1.65-.725-.455-.456-.641-1.023-.725-1.65-.08-.595-.08-1.345-.08-2.243V8.814a2.28 2.28 0 0 1-1.527-2.15v-.438c0-.208 0-.368.015-.512a2.75 2.75 0 0 1 2.45-2.45c.143-.014.303-.014.511-.014m.05 5.69v3.63c0 .964.002 1.612.067 2.095.062.461.17.659.3.789s.328.237.79.3c.482.064 1.13.066 2.094.066h3.45c.964 0 1.612-.002 2.095-.066.461-.063.659-.17.789-.3s.238-.328.3-.79c.064-.482.066-1.13.066-2.094V8.94h-9.95Zm-.011-4.19c-.265 0-.34.001-.395.007A1.25 1.25 0 0 0 3.557 5.87a5 5 0 0 0-.007.395v.398c0 .43.348.777.777.777h11.45a.777.777 0 0 0 .777-.777v-.398c0-.265-.001-.34-.007-.395a1.25 1.25 0 0 0-1.113-1.113 5 5 0 0 0-.395-.007z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7.852 11.736a.75.75 0 0 1 .75-.75h2.9a.75.75 0 0 1 0 1.5h-2.9a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArchive;
